function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { assert } from '@ember/debug';
import Service from '@ember/service';
export default class AnalyticsConfigService extends Service {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  constructor(owner) {
    super(owner);
    _defineProperty(this, "_config", void 0);
    let config = owner.resolveRegistration('config:environment');
    this._config = config.analytics || {
      apiUrl: ''
    };
  }
  get apiUrl() {
    assert('You have to specify "analytics.apiUrl" in your config/environment.js', !!this._config.apiUrl);
    return this._config.apiUrl;
  }
  get readKey() {
    return this._config.readKey;
  }
  get writeKey() {
    return this._config.writeKey;
  }
}